angular.module('rjmNg.services').factory 'rjdl', [
  '$q'
  'Columns'
  'StructureCache'
  'columnEditor'
  'rjdlDefinitionInjector'
  (
    $q
    Columns
    StructureCache
    columnEditor
    rjdlDefinitionInjector
  ) ->

    rjdlService = {}

    # Returns a converter for a schema service column object, or throws an
    # exception if a valid converter cannot be found.
    rjdlService.getConverter = (column) ->
      if column?.type isnt 'derivative' or not column?.properties?.derivative_type?
        throw columnEditor.getError('Invalid derivative column', 'The column had an invalid type or derivative type.')
      else if not (converter = rjdlDefinitionInjector.getConverterForType(column.properties.derivative_type, column))?
        throw columnEditor.getError('Unsupported definition', 'This definition type is not currently supported by the column editor.')

      else
        return converter

    # A wrapper for getConverter() which returns null if unable to find a valid
    # converter. (As opposed to throwing an exception.)
    rjdlService.getConverterOrNull = (column) ->
      try
        return rjdlService.getConverter(column)
      catch
        return null

    # Convert a column editor object to a column.
    rjdlService.toColumn = (table, field) ->
      deferred = $q.defer()

      StructureCache.getStructureAndReferences().then(
        (result) ->
          converter = rjdlDefinitionInjector.getConverterForType(field.definition)
          if not converter?
            deferred.reject columnEditor.getError('Internal error', 'Unknown definition. No converter exists for this object.')
            return

          try
            if not field.name? or field.name.length is 0
              deferred.reject(columnEditor.getError('Missing property', 'The name of this column is not set.'))

            converter.validateField(field)
            column = converter.toColumn(result.structure, table, field)
            deferred.resolve(column)
          catch error
            deferred.reject columnEditor.getError('Invalid column', error)
        ,
        (error) ->
          deferred.reject columnEditor.getError('Internal server error', error)
      )

      return deferred.promise

    # Attempt to identify one of the various errors thrown by Columns.* and
    # get an error properly formatted for the column editor.
    parseError = (error) ->

      if error.statusText? and error.data?.message?
        # HTTP error response with data
        columnEditor.getError(error.statusText, error.data.message)

      else if error.data?.error? and error?.data?.errors?
        # Schema service error response
        columnEditor.getError.apply(this, [error.data.error].concat(error.data.errors))

      else if error.status? and error.config?.method?
        # HTTP error with no response data
        columnEditor.getError('Internal server error')

      else
        # Generic error--just stringify everything
        columnEditor.getError('Error!', JSON.stringify(error))

    rjdlService._parseError = parseError

    # Convert a column editor object to a column, and then call an
    # asynchronous function with the column. Returns the result of that call.
    callWithColumn = (table, field, funcToCall, deleteColumnId=false, successCallback=null) ->
      deferred = $q.defer()
      promises = [rjdlService.toColumn(table, field)
                  Columns.query
                    tid: table
                    state: ["active"]]

      $q.all(promises).then(
        ([column, columns]) ->
          if deleteColumnId
            delete column.id
            delete column.column_name
          # Note that Column.save and Column.create may throw exceptions
          try
            dupCols = columns.filter (col) ->
              col.id isnt column.id and col.name.toLowerCase() is column.name.toLowerCase()
            if dupCols.length
              throw "Name '#{column.name}' has already been taken. Name must be unique in table (case insensitive)."
            funcToCall(column).then (columnResponse) ->
              if successCallback?
                successCallback(field, columnResponse)
              deferred.resolve(columnResponse)
            , (error) ->
              deferred.reject parseError(error)
          catch error
            deferred.reject parseError(error)

        , (error) ->
          deferred.reject(error)
      )

      return deferred.promise

    rjdlService._callWithColumn = callWithColumn

    # Save a new column editor object. Returns a promise.
    rjdlService.create = (table, field) ->
      callWithColumn(table, field, Columns.create, true, (field, columnResponse) ->
        field.id = columnResponse.id
      )

    # Save an existing column editor object. Returns a promise.
    rjdlService.save = (table, field) ->
      callWithColumn(table, field, Columns.save)

    # Given an id of an existing column, return a column editor object.
    rjdlService.fromColumnId = (columnId) ->
      deferred = $q.defer()
      StructureCache.getStructure().then(
        (structure) ->
          column = structure.columns[columnId]
          try
            converter = rjdlService.getConverter(column)
          catch error
            deferred.reject(error)
            return

          converter = rjdlDefinitionInjector.getConverterForType(column.properties.derivative_type)

          StructureCache.getReferences().then(
            (result) ->

              if not converter?
                deferred.reject columnEditor.getError('Unsupported definition', 'This definition type is not currently supported by the column editor.')
              else
                try
                  result = converter.fromColumn(structure, column, result.references)
                  deferred.resolve(result)
                catch error
                  deferred.reject columnEditor.getError('Invalid column', error)

            , (error) -> # References failed
              deferred.reject columnEditor.getError('Internal server error', error)
        )
        , (error) -> # Structure failed
          deferred.reject columnEditor.getError('Internal server error', error)
      )

      return deferred.promise

    # Definition categories
    categories = [
        category: 'sameTable'
        name: 'Same Table'
        description: 'Create new columns based on input data from a single table.'
      ,
        category: 'oneToMany'
        name: 'One to Many'
        description: 'Copy a value from one table to another via a foreign key relationship. Example: Copy a user\'s e-mail address from a "users" table to an "orders" table.'
      ,
        category: 'manyToOne'
        name: 'Many to One'
        description: 'Aggregate matching values via a foreign key relationship. Example: Sum up "Total Lifetime Spending" per user by aggregating data from an "orders" table.'
    ]

    rjdlService.getSubitem = (converter, subtype) ->
      unless converter?
        return null

      _.find(converter.subtypes, (subitem) ->
        (not subtype? and not subitem.subtype?) or
        subitem.subtype is subtype)

    # Given some definition type and optionally subtype, get a corresponding
    # definition list item.
    rjdlService.getPropertiesForDefinition = (type, subtype) ->
      converter = rjdlDefinitionInjector.getConverterForType(type)

      subitem = rjdlService.getSubitem(converter, subtype)

      unless subitem?
        return null

      arg: converter.arg
      category: converter.category
      definition: converter.definition
      description: subitem.description
      symbol: subitem.symbol
      typeFilter: subitem.typeFilter
      filtersSupported: converter.filtersSupported
      helpLink: subitem.helpLink

    ###

    The definition list format looks like this:

    definitions = [
        name: 'Single Row'
        description: 'Use these definitions on columns from this table, or from tables which have a one-to-one or many-to-one reference with this table.'
        definitions: [
            type: 'relocated_field'
            arg: 'tableColumn'
            description: 'An existing table column'
          ,
            type: 'age'
            symbol: 'AGE'
            arg: 'column'
            description: 'The number of seconds between now and some DATETIME value.'
        ]
      ,
        name: 'Multiple Row'
        description: 'Use these aggregate definitions on columns from tables which have a one-to-many reference with this table.'
        definitions: [
            type: 'aggregate'
            subtype: 'avg'
            symbol: 'AVG'
            arg: 'tableColumn'
            description: 'The average of all matching values.'
        ]
    ]

    ###

    # Get a list of definitions, dynamically populated from the available
    # definitions converters.
    rjdlService.getDefinitionList = () ->
      converters = rjdlDefinitionInjector.getConverters()

      definitionList = []

      for category in categories
        listItem =
          name: category.name
          description: category.description
          definitions: []
          id: category.category

        for converter in converters when converter.category is category.category
          for subtype in converter.subtypes
            listItem.definitions.push
              definition: converter.definition
              arg: converter.arg
              symbol: subtype.symbol
              description: subtype.description
              subtype: subtype.subtype

        if listItem.definitions.length > 0
          definitionList.push(listItem)

      return definitionList

    rjdlService

]
